import type { User } from '../../../../core/interfaces/backend/usuarios/usuarios.administration.interface';
import type { Role } from '../../../../core/interfaces/backend/roles/roles.administration.interface';
import type { Assignment } from '../../../../core/interfaces/backend/reasignaciones_usuarios/reasignaciones_usuarios.administration.interface';
import { Component, inject, Input, Output, EventEmitter, OnChanges, computed, signal, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministracionService } from '../../../../services/backend/administracion/administracion.service';
import { AdminDataTableComponent, GridRow } from '../../../../shared/admin-data-table/admin-data-table.component';
import { GovcoConfirmModalComponent } from '../../../../shared/govco/govco-confirm-modal/govco-confirm-modal.component';

@Component({selector:'sr-gestionar-usuario',standalone:true,imports:[FormsModule, GovcoConfirmModalComponent],templateUrl:'./gestionar-usuario.component.html',styleUrl:'./gestionar-usuario.component.css'})
export class GestionarUsuarioComponent {
  readonly api=inject(AdministracionService);
  @Input({required:true}) user!:User;
  @Input() readOnly=false;
  @Output() readonly closed=new EventEmitter<void>();
  active=true; roleIds:string[]=[];
  ngOnChanges():void {this.active=this.user.active;this.roleIds=[...this.user.roleIds];}
  get confirmationMessage():string{return 'Usuario: '+this.user.name+'. Se guardarán su estado y sus roles.';}
  toggle(id:string,checked:boolean):void {this.roleIds=checked?[...this.roleIds,id]:this.roleIds.filter(r=>r!==id);}
  askSave():void {this.decision='save';}
  persist():void {this.api.save('/tg/usuarios/administration/save-user',{id:this.user.id,active:this.active,roleIds:this.roleIds,instrumentId:this.api.instrumentId()},()=>this.closed.emit());}
  decision: 'save'|'cancel'|null=null;
  validation='';
  get confirmTitle(): string { return this.decision==='save'?'¿Está seguro que desea guardar los cambios realizados?':'¿Está seguro que desea cancelar los cambios realizados?'; }
  confirmDecision(): void { const action=this.decision; this.decision=null; if(action==='cancel') this.closed.emit(); else if(action==='save') this.persist(); }

}
